import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {withRouter} from 'react-router';
import {Button, Form, Icon, Message, Container} from 'semantic-ui-react';
import {isNil} from 'ramda';
import {findTeam} from '../../api';
import {FormInputLogin} from './FormInputMix';
import {ButtonsGroup, DefaultButton, GreenButton} from '../Button/ButtonMix';

const StyledContainer = styled(Container)`
  margin-bottom: 20px; 
`;

class FindTeamForm extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      error: null,
      studentEmail: null,
      studentEmailError: null,
      selectedTeam: null
    };
  }
  
  handleChange = (e, {name, value}) => this.setState({[name]: value});
  
  handleSubmit = () => {
    this.setState({error: null, studentEmail: null, selectedTeam: null});
    const {studentEmail} = this.state;
    
    // validate email
    const isStudentEmailValid = studentEmail && studentEmail.includes('@');
    this.setState({studentEmailError: !isStudentEmailValid ? 'Invalid email' : null});
    
    if (!isStudentEmailValid) return;
    
    return findTeam(studentEmail)
      .then(response => {
        this.setState({selectedTeam: response.data});
      })
      .catch(e => {
        e.response ? this.setState({error: e.response.data.error}) : this.setState({error: e.message});
      });
  };
  
  render() {
    const {error, studentEmailError, selectedTeam} = this.state;
    const {router} = this.props;
    
    const isError = !isNil(error) || !isNil(studentEmailError);

    const onJoinStudentTeam = team => !isNil(team) ? router.push(`sign-up/join/teams/${team.id}`) : null;
    const teamName = isNil(selectedTeam) ? null : selectedTeam.name;
    
    return (
      <Form error={isError} success={!isNil(selectedTeam)} onSubmit={this.handleSubmit}>
        <StyledContainer textAlign="center" style={{color: '#ffffff'}}>
          <p>Let’s find the team captain by entering their email.</p>
        </StyledContainer>
        <FormInputLogin label="Email address" type="text" name="studentEmail" onChange={this.handleChange} placeholder="Enter the team captain's email" required/>
        <Message error icon>
          <Message.Content>
            <Message.Header>Error</Message.Header>
            <p>{[error, studentEmailError].filter(e => !isNil(e)).join(', ')}</p>
          </Message.Content>
        </Message>
        <Message success icon>
          <Icon name="check"/>
          <Message.Content>
            <Message.Header>Team found!</Message.Header>
            Would you like to join team "{teamName}"?
          </Message.Content>
          <Button type="button" onClick={() => onJoinStudentTeam(selectedTeam)}>Join team</Button>
        </Message>
        <ButtonsGroup>
          <DefaultButton onClick={router.goBack}>Cancel</DefaultButton>
          <GreenButton fluid>Find</GreenButton>
        </ButtonsGroup>
      </Form>
    );
  }
}

FindTeamForm.propTypes = {
  router: PropTypes.object.isRequired
};

export default withRouter(FindTeamForm);



// WEBPACK FOOTER //
// ./src/components/Form/FindTeamForm.js